module.exports = __webpack_public_path__ + "media/images/official/special_workcation_03-0847dd3487f504c596df69feb1347f6e.jpg";